<template>
    <div class="duplicate-review-decision-panel">
        <el-radio-group class="duplicate-review-decision-panel__group" :value="value" size="mini" @input="$emit('input', $event)">
            <el-radio-button label="pending">待定</el-radio-button>
            <el-radio-button label="useful">有用</el-radio-button>
            <el-radio-button label="not-useful">无用</el-radio-button>
        </el-radio-group>
        <el-button
            class="duplicate-review-decision-panel__save"
            size="mini"
            type="primary"
            :loading="saving"
            @click="$emit('save')"
        >
            保存判断
        </el-button>
    </div>
</template>

<script>
export default {
    name: "DuplicateReviewDecisionPanel",
    props: {
        value: {
            type: String,
            default: "pending",
        },
        saving: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped>
.duplicate-review-decision-panel {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
    margin-top: 0;
}

.duplicate-review-decision-panel__group,
.duplicate-review-decision-panel__save {
    width: 100%;
}
</style>
